
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.163","height":"12.838","viewBox":"0 0 13.163 12.838"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.761 12.837a1.4 1.4 0 01-1.063-.489L.337 8.427a1.4 1.4 0 012.127-1.823l2.2 2.563L11.608.793c1.075-1.506 2.2-.672 1.12.84L5.9 12.251a1.4 1.4 0 01-1.078.585z","fill":"#0db14b"}})])
          )
        }
      }
    